






















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import CreditCard from '@/components/CreditCard.vue'
import eCheckCard from '@/components/eCheckCard.vue'
import Select from '@/components/Select.vue'
import Input from '@/components/inputs/Input.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import PaymentMethodModal from '@/components/modals/PaymentMethodModal.vue'
import {
  EPaymentMethodType,
  EUserPermissions,
  EUserType,
  IFacility,
  IResidentEventHistoryFiltersDTO,
  IResidentPaymentMethod
} from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import Confirm from '@/components/Confirm.vue'
import DeletePaymentMethodModal from '@/views/resident-portal/components/DeletePaymentMethodModal.vue'
import DeletePaymentMethodErrorModal from '@/views/resident-portal/components/DeletePaymentMethodErrorModal.vue'
import Card from '@/components/Card.vue'
import NoRows from '@/components/tables/NoRows.vue'

@Component({
  components: {
    NoRows,
    Card,
    PaymentMethodModal,
    CreditCard,
    eCheckCard,
    Select,
    SearchInput,
    DateInput,
    DateTimeLabel,
    Input,
    Confirm,
    DeletePaymentMethodModal,
    DeletePaymentMethodErrorModal
  }
})
export default class ResidentCreditCardsBlock extends Vue {
  historyNote: string = ''
  paymentMethodModalVisible: boolean = false
  user: User = Api.getUser() as User
  isCreditCardLoading: boolean = false
  EUserPermissions: any = EUserPermissions
  residentHistoryFilters: IResidentEventHistoryFiltersDTO = {}
  editPaymentData: IResidentPaymentMethod | null = null
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  deleteErrorMessage: string = ''
  cardIdToBeDeleted: number | null = null
  isDeletePaymentMethodErrorModalOpen: boolean = false

  get residentId () {
    return this.user.getResidents()[0]
  }

  get paymentMethods () {
    let methods = this.resident.paymentMethods
    if (this.ccDisabled) {
      methods = (this.resident.paymentMethods as IResidentPaymentMethod[]).filter(m =>
        m.type !== EPaymentMethodType.CREDIT_CARD
      )
    }
    return methods
  }

  get resident () {
    return this.$store.state.resident
  }
  
  get ccDisabled () {
    const selectedResident = this.resident.selectedResident
    const facility = (selectedResident.facility as IFacility)
    const isDisabled = !facility.allowCCProcessing ||
     (this.user.data.type === EUserType.RESIDENT && facility.isResidentPortalNoCC)
    return isDisabled
  }

  get ccPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.CREDIT_CARD
    })
  }

  get echeckPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.ECHECK
    })
  }

  async mounted (): Promise<void> {
    this.isCreditCardLoading = true
    await this.residentModuleInstance.getResidentPaymentMethods(this.residentId)
    this.isCreditCardLoading = false
  }

  showPaymentModal () {
    this.paymentMethodModalVisible = true
  }

  openDeletePaymentMethodModal (id: number): void {
    this.cardIdToBeDeleted = id
  }

  closeDeletePaymentMethodModal () {
    this.cardIdToBeDeleted = null
  }

  openDeletePaymentMethodErrorModal () {
    this.isDeletePaymentMethodErrorModalOpen = true
  }

  closeDeletePaymentMethodErrorModal () {
    this.isDeletePaymentMethodErrorModalOpen = false
  }

  async makePaymentMethodPrimary (paymentMethodId: number): Promise<void> {
    await this.residentModuleInstance.makePaymentMethodPrimary({
      residentId: this.residentId,
      paymentMethodId
    })
  }

  async deletePaymentMethod (paymentMethodId: number) {
    this.closeDeletePaymentMethodModal()
    const response = await this.residentModuleInstance.deletePaymentMethod(paymentMethodId)
    if (response !== 'OK') {
      if (response.message) {
        this.deleteErrorMessage = response.message
        this.openDeletePaymentMethodErrorModal()
      }
    }
  }

  closePaymentMethodModal (): void {
    this.paymentMethodModalVisible = false
    this.editPaymentData = null
  }

  async makePrimaryPaymentMethod (id: number): Promise<void> {
    await this.residentModuleInstance.makePaymentMethodPrimary({ residentId: this.residentId, paymentMethodId: id })
  }

  openEditModal (id: number): void {
    this.editPaymentData = this.paymentMethods.find((pm: IResidentPaymentMethod) => pm.id === id)
    this.showPaymentModal()
  }
}
